import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/IcCardRegister.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-23035445")

_pushScopeId("data-v-23035445")
const _hoisted_1 = { class: "popup-card-register" }
const _hoisted_2 = { class: "text-2xl mb-6" }
const _hoisted_3 = { class: "popup-content flex justify-between relative" }
const _hoisted_4 = { class: "popup-content-input" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "w-64" }
const _hoisted_7 = { class: "font-bold text-sm mb-1" }
const _hoisted_8 = { class: "w-64" }
const _hoisted_9 = { class: "font-bold text-sm mb-1" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "mr-8" }
const _hoisted_12 = { class: "text-sm font-bold mb-1" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "mr-8" }
const _hoisted_15 = { class: "text-sm font-bold mb-1" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "mr-8" }
const _hoisted_18 = { class: "text-sm font-bold mb-1" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = { class: "mr-8" }
const _hoisted_21 = { class: "text-sm font-bold mb-1" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "text-base mb-4 mt-6" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "font-bold text-sm mb-1" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "popup-content-img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_27 = { class: "flex justify-between items-center mt-6" }
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-4xl" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-4xl" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _component_Broadcast = _resolveComponent("Broadcast")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShow = $event)),
    width: "1086px",
    noScrollBody: ""
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('icCardRegistration')), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('timeCardNew.employeeNumber')), 1),
                _createVNode(_component_Input, {
                  placeholder: _ctx.t('pleaseEnter')
                }, null, 8, ["placeholder"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('name')), 1),
                _createVNode(_component_Input, {
                  placeholder: _ctx.t('pleaseEnter')
                }, null, 8, ["placeholder"])
              ])
            ], 512), [
              [_vShow, _ctx.isHandInputCardNumber]
            ]),
            _withDirectives(_createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('staffCode')), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.infoEmployee?.pp_employee_code), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('affiliationOrganization')), 1),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.infoEmployee?.unit_name), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('staffName')), 1),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.infoEmployee?.pp_employee_name), 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('individualApplicationPolicyCreate.workingStyle')), 1),
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.infoEmployee?.working_style_name), 1)
              ])
            ], 512), [
              [_vShow, !_ctx.isHandInputCardNumber]
            ]),
            _createVNode("div", _hoisted_23, _toDisplayString(_ctx.t('scanAndRegisterIdm')), 1),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.t('cardNumberIdm')), 1),
              _createVNode(_component_Input, {
                modelValue: _ctx.cardNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cardNumber = $event)),
                placeholder: _ctx.t('pleaseEnter')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _hoisted_26,
          _withDirectives(_createVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.connectIcCard && _ctx.connectIcCard(...args))),
            class: "connect-card cursor-pointer text-white absolute py-1 px-2 rounded"
          }, _toDisplayString(_ctx.t('cardRegistration.connectPaSoRi')), 513), [
            [_vShow, !_ctx.isHandInputCardNumber]
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_Broadcast, { class: "mr-2" }),
            _createVNode("span", {
              class: ["font-bold", _ctx.isConnect ? 'ic-connect' : 'ic-disconnect']
            }, _toDisplayString(_ctx.t('theIcCardReader')), 3)
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode(_component_Button, {
              onClick: _ctx.handleCancel,
              variant: "outline-primary",
              class: "mr-4"
            }, {
              default: _withId(() => [
                _hoisted_30,
                _createTextVNode(" " + _toDisplayString(_ctx.t('overtimeRegister.buttonCancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, { onClick: _ctx.handleSubmitIcCardNumber }, {
              default: _withId(() => [
                _hoisted_31,
                _createTextVNode(" " + _toDisplayString(_ctx.t('approvedFlow.toRegister')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})